// removed by extract-text-webpack-plugin
module.exports = {"root":"PrivacyPolicy__root__3Zh0L","lastUpdated":"PrivacyPolicy__lastUpdated__1aNse"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PrivacyPolicy/PrivacyPolicy.css
// module id = 2058
// module chunks = 0